import { noop } from 'lodash';

// Can be used to create a Proxy handler for implementing custom getters/setters for objects
export const createProxyHandler = <T extends Object>(cb: (t: T) => void = noop, path: string[] = []) => ({
	get: (target: T, key: keyof T): any => {
		if (key == 'isProxy') return true;
		if (typeof target[key] === 'object' && target[key] != null)
			return new Proxy(
				target[key],
				createProxyHandler<any>(() => cb(target), [...path, key as string])
			);
		return target[key];
	},
	set: (target: T, key: keyof T, value: any) => {
		target[key] = value;
		cb({ ...target });
		return true;
	},
});
